import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';

import { DatacenterType } from '../../../../shared/models/datacenter-aggrid-view';
import { ORDER_NUMBER_OPTIONS } from '../../../../shared/models/list';
import { CUSTOMER } from '../../../../shared/models/settings';
import { UNDERSCORE } from '../../../../shared/utils/constant';
import { Document, DocumentLine } from '../../../models/document';
import { DocumentService } from '../../../services/documents.service';
import { SafeUrlPipe } from '../../../../shared/pipes/safeurl.pipe';
import { DatePipe } from '../../../../shared/pipes/date.pipe';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-order-acknowledgment',
	templateUrl: './order-acknowledgment.component.html',
	styleUrl: '../commercial-documents-list.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MatIconModule,
		TranslateModule,
		RouterLink,
		MatRippleModule,

		MatButtonModule,
		NgFor,
		LoadingSpinnerComponent,
		DatePipe,
		SafeUrlPipe
	]
})
export class OrderAcknowledgComponent implements OnInit {
	@Input() document?: Document;
	@Input() orderDisplay?: keyof typeof ORDER_NUMBER_OPTIONS;
	@Input() getOrderName?: (document: Document, docLine: DocumentLine) => string;
	@Output() readonly createFilter = new EventEmitter<{ document: Document; filterType: DatacenterType }>();

	readonly UNDERSCORE = UNDERSCORE;
	orderLable = '';
	constructor(
		private readonly documentService: DocumentService
	) {}

	ngOnInit() {
		this.orderLable = this.orderDisplay === CUSTOMER
			? 'commercial-documents.customer-order-number'
			: 'commercial-documents.supplier-order-number';
	}

	getCustomerOrderName(document: Document, docLine: DocumentLine): string {
		if (this.getOrderName === undefined) {
			return '';
		}
		return this.getOrderName(document, docLine);
	}

	callFilter(document: Document, filterType: DatacenterType) {
		this.createFilter.emit({ document, filterType });
	}

	downloadDocument(id: number, filename: string) {
		return this.documentService.getDownloadDocumentUrl(id, filename);
	}

	getDocumentURL(id: number, filename: string) {
		return this.documentService.getViewDocumentUrl(id, filename);
	}
}
